<template>
  <nav class="navbar is-transparent">
    
    <!-- navbar-brand: the left side of the navbar, always visible, which usually contains the logo and optionally some links or icons -->
    <div class="navbar-brand">
      <div class="navbar-item">
        <img :src="iconPath" alt="Wise Vet Live" height="100%">
      </div>
      <!-- Home icon -->
      <router-link :to="landingScreen" class="navbar-item" v-if="getAccessType != 'newCustomer'">
        <span class="icon-text has-text-success">
          <span class="icon">
            <i class="fas fa-home fa-border"></i> <!-- Replace with your home icon, e.g., Font Awesome -->
          </span>
          <span>{{ $t('Navbar.Start') }}</span> <!-- Text "Home" -->
        </span>
      </router-link>
      <!--<div class="navbar-item">
        {{ getAccessType }}
      </div>
      -->
      <!-- navbar-burger: the hamburger icon, which toggles the navbar menu on touch devices -->
      <div class="navbar-burger" data-target="navbarExampleTransparentExample">
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>

    <!-- navbar-menu: the right side of the navbar, hidden on touch devices, visible on desktop -->
    <div id="navbarExampleTransparentExample" class="navbar-menu">
      
      <!-- navbar-start: the left part of the menu, which appears next to the navbar brand on desktop -->
      <div class="navbar-start">
        <!--        <router-link to="/backend" class="navbar-item" href="/">-->
        <!--          Backend-->
        <!--        </router-link>-->
      </div>

      <!-- navbar-end: the right part of the menu, which appears next to the navbar brand on desktop -->
      <div class="navbar-end" v-if="getAccessType != 'newCustomer'">
        <!-- Veterinarians button for Manager Mode -->
        <div class="navbar-item" v-if="getAccessType == 'manager' && getMngMode != 'vets' && !getShowingUserData && !getCustDetailing && !getShowingAppointmentData">
          <div class="field is-grouped">
            <p class="control">
              <a @click="switchManagementMode('vets')" class="button is-primary">
                {{ $t('Navbar.Veterinarians') }}
              </a>
            </p>
          </div>
        </div>
        <!-- Managers button for Manager Mode -->
        <div class="navbar-item" v-if="getAccessType == 'manager' && getMngMode != 'managers' && !getShowingUserData && !getCustDetailing && !getShowingAppointmentData">
          <div class="field is-grouped">
            <p class="control">
              <a @click="switchManagementMode('managers')" class="button is-primary">
                {{ $t('Navbar.Managers') }}
              </a>
            </p>
          </div>
        </div>
        <!-- Customers button for Manager Mode -->
        <div class="navbar-item"
          v-if="getAccessType == 'manager' && getMngMode != 'customers' && !getShowingUserData && !getCustDetailing && !getShowingAppointmentData">
          <div class="field is-grouped">
            <p class="control">
              <a @click="switchManagementMode('customers')" class="button is-primary">
                {{ $t('Navbar.Customers') }}
              </a>
            </p>
          </div>
        </div>
        <!-- Appointments button for Manager Mode -->
        <div class="navbar-item"
          v-if="getAccessType == 'manager' && getMngMode != 'appointments' && !getShowingUserData && !getCustDetailing && !getShowingAppointmentData">
          <div class="field is-grouped">
            <p class="control">
              <a @click="switchManagementMode('appointments')" class="button is-primary">
                {{ $t('Navbar.Appointments') }}
              </a>
            </p>
          </div>
        </div>
        <!-- Products button for Manager Mode -->
        <div class="navbar-item"
          v-if="getAccessType == 'manager' && getMngMode != 'products' && !getShowingUserData && !getCustDetailing && !getShowingAppointmentData">
          <div class="field is-grouped">
            <p class="control">
              <a @click="switchManagementMode('products')" class="button is-primary">
                {{ $t('Navbar.Products') }}
              </a>
            </p>
          </div>
        </div>
        
        <!-- Avail. Config button for Vet Mode -->
        <div class="navbar-item"
          v-if="getAccessType == 'vet' && getVetMode != 'availabilityconfig' && !getShowingUserData && !getCustDetailing && getHasAssociatedCalendar && !getShowingAppointmentData">
          <div class="field is-grouped">
            <p class="control">
              <a @click="switchVetMode('availabilityconfig')" class="button is-primary">
                {{ $t('Navbar.AvailConfig') }}
              </a>
            </p>
          </div>
        </div>
        <!-- Avail. Slots button for Vet Mode -->
        <div class="navbar-item"
          v-if="getAccessType == 'vet' && getVetMode != 'availabilityslots' && !getShowingUserData && !getCustDetailing && getHasAssociatedCalendar && !getShowingAppointmentData">
          <div class="field is-grouped">
            <p class="control">
              <a @click="switchVetMode('availabilityslots')" class="button is-primary">
                {{ $t('Navbar.AvailSlots') }}
              </a>
            </p>
          </div>
        </div>
        <!-- Customers button for Vet Mode -->
        <div class="navbar-item"
          v-if="getAccessType == 'vet' && getVetMode != 'customers' && !getShowingUserData && !getCustDetailing && !getShowingAppointmentData">
          <div class="field is-grouped">
            <p class="control">
              <a @click="switchVetMode('customers')" class="button is-primary">
                {{ $t('Navbar.Customers') }}
              </a>
            </p>
          </div>
        </div>
        <!-- Appointments button for Vet Mode -->
        <div class="navbar-item"
          v-if="getAccessType == 'vet' && getVetMode != 'appointments' && !getShowingUserData && !getCustDetailing && !getShowingAppointmentData">
          <div class="field is-grouped">
            <p class="control">
              <a @click="switchVetMode('appointments')" class="button is-primary">
                {{ $t('Navbar.Appointments') }}
              </a>
            </p>
          </div>
        </div>
        <div class="navbar-item" v-if="!getShowingUserData && !getCustDetailing && !getShowingAppointmentData">
          <div class="field is-grouped">
            <p class="control">
              <a @click="showUserdata" class="button is-primary">
                {{ $t('Navbar.MyData') }}
              </a>
            </p>
          </div>
        </div>
        <div class="navbar-item" v-if="getShowingUserData && !getShowingPetRecord && !getCustDetailing && !getEditingCustomer && !(getAccessType == 'vet' && !getHasAssociatedCalendar) && !getShowingAppointmentData">
          <div class="field is-grouped">
            <p class="control">
              <a @click="endShowData" class="button is-primary">
                {{ $t('General.Back') }}
              </a>
            </p>
          </div>
        </div>
        <div class="navbar-item">
          <div class="field is-grouped">
            <p class="control">
              <a class="button is-danger is-outlined" @click="doLogout">
                <span class="icon">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                    stroke="currentColor" class="w-6 h-6">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M5.636 5.636a9 9 0 1012.728 0M12 3v9" />
                  </svg>
                </span>
                &nbsp;
                <span>  {{ $t('Navbar.Logout') }}
              </span>
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { mapActions, mapGetters } from "vuex";

export default defineComponent({
  name: "Navbar",
  data() {
    return {
      componentName: "Navbar",
      iconPath: process.env.VUE_APP_ICON_URL // Access the Icon URL from environment variables
    }
  },
  components: {},
  props: [],
  computed: {
    ...mapGetters(['getAccessType', 'getShowingUserData', 'getShowingPetRecord', 'getMngMode', 'getCustDetailing', 'getVetMode',
      'getEditingCustomer', 'getHasAssociatedCalendar', 'getShowingAppointmentData']),
  
    landingScreen() {
      return `/${this.getAccessType}`;
    }
  },
  methods: {
    ...mapActions(['logout', 'toggleShowingUserData', 'iniVetsManagement', 'iniManagersManagement', 'iniCustomersManagement', 'fetchUsers',
      'iniVetAvailabilityConfig', 'iniVetAvailabilitySlots', 'iniVetCustomers', 'toggleShowingPetRecord', 'toggleCustDetailing', 'iniVetAppointments',
      'iniAppointmentsManagement', 'iniProductsManagement']),
      
    doLogout() {
      this.logout()
      this.$router.push('/')
    },
    

    showUserdata() {
      const language = this.$i18n.locale;
      const accessType = this.getAccessType;
      this.toggleShowingUserData(false);
      console.log(accessType);
      let route;
      switch (accessType) {
        case "customer":
          route = "/customerdata";
          break;
        case "manager":
          route = "/managerdata";
          break;
        case "vet":
          route = "/vetdata";
          break;
      }
      this.$router.push({ path: route, query: { lang: language, access: accessType } });
    },

    endShowData() {
      // this.$router.go(-1);
      this.toggleShowingUserData(true);
      this.$router.push(`/${this.getAccessType}`)
    },

    populateUsersList(mode: string) {
      var usersType: string;
      switch (mode) {
        case "vets":
          usersType = 'vet'
          break;
        case "managers":
          usersType = 'manager'
          break;
        case "customers":
          usersType = 'customer'
          break;
        case "appointments":
          usersType = 'vet'
          break;
        default:
          usersType = 'customer'
          break;
      }
      this.fetchUsers(usersType);
    },

    switchManagementMode(newMngMode: string) {
      switch (newMngMode) {
        case "vets":
          this.iniVetsManagement();
          break;
        case "managers":
          this.iniManagersManagement();
          break;
        case "customers":
          this.iniCustomersManagement();
          break;
        case "appointments":
          this.iniAppointmentsManagement();
          break;
        case "products":
          this.iniProductsManagement();
          break;
        default:
          this.iniCustomersManagement();
          break;
      }
      this.populateUsersList(this.getMngMode);
    },

    switchVetMode(newVetMode: string) {
      switch (newVetMode) {
        case "availabilityconfig":
          this.iniVetAvailabilityConfig();
          break;
        case "availabilityslots":
          this.iniVetAvailabilitySlots();
          break;
        case "customers":
          this.iniVetCustomers();
          break;
        case "appointments":
          this.iniVetAppointments();
          break;
        default:
          this.iniVetCustomers();
          break;
      }
    }
  },
  watch: {},
  mounted() {
    switch (this.getAccessType)
    {
      case "manager":
        this.populateUsersList(this.getMngMode);
        break;
      case "vet":
        this.populateUsersList('customers');
        break;
    }
  }
})
</script>

<style scoped></style>


